<template>
  <ItemListCollectionWrapper
    collectionModule="UserCollection"
    defaultSortBy="email"
    :refreshKey="refreshKey"
    rowsPerPageLocalStorageKey="10-11-2021-administrators-per-page"
  >
    <template
      v-slot="slotProps"
    >
      <ItemListPagination
        :columns="$options.columns"
        :currentPageNum="slotProps.currentPageNum"
        data-test-id="AdministratorsList_itemList"
        :isLoading="slotProps.loading"
        :itemComponent="$options.AdministratorRow"
        :rowsPerPage="slotProps.rowsPerPage"
        :showEmptyState="slotProps.showEmptyState"
        :sortBy="slotProps.sortBy"
        :sortDirection="slotProps.sortDirection"
        :tableData="slotProps.tableData"
        :totalCount="slotProps.totalCount"
        @pageChange="slotProps.handlePageChange"
        @sortColumn="slotProps.handleSortColumn"
      >
        <template v-slot:toolbar>
          <Toolbar
            :addButtonDisabled="disableAddAdmin"
            :addRoute="$options.administratorsAddRoute"
            :searchTerm="slotProps.getSearchTerm"
            searchPlaceholder="Search email addresses"
            :shouldFocusSearch="slotProps.shouldFocusSearch"
            @triggerSearch="slotProps.handleEnterSearchTerm"
          />
        </template>
        <template v-slot:emptyState>
          <NoSearchResults
            :src="$options.noResultsIllustration"
            @click="slotProps.clearSearchTerm"
          />
        </template>
      </ItemListPagination>
    </template>
  </ItemListCollectionWrapper>
</template>

<script>
import {
  ItemListPagination,
  NoSearchResults,
  Types,
} from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';
import AdministratorRow from 'client/settings/AdministratorSettings/AdministratorList/AdministratorRow.vue';
import Constants from 'client/util/Constants';
import ItemListCollectionWrapper from 'client/components/ItemList/ItemListCollectionWrapper.vue';
import Toolbar from './Toolbar/Toolbar.vue';

const { Column } = Types;
const { noResultsIllustration } = Constants;
const columns = [
  Column({
    label: 'Name',
    dataFieldName: 'lastname',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'Email',
    dataFieldName: 'email',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'Role',
    dataFieldName: 'roleName',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'MFA Status',
    dataFieldName: 'mfaStatus',
    width: '25ch',
  }),
];

export default {
  name: 'AdministratorsList',

  components: {
    ItemListPagination,
    ItemListCollectionWrapper,
    NoSearchResults,
    Toolbar,
  },

  columns,
  noResultsIllustration,
  AdministratorRow,

  administratorsAddRoute: '/settings/administrators/new',

  props: {
    refreshKey: {
      type: Number,
      default: null,
    },
  },

  computed: {
    ...mapGetters('SettingsModule', {
      isAdminWithBilling: 'isAdminWithBilling',
      user: 'getUser',
    }),

    disableAddAdmin() {
      return !this.isAdminWithBilling;
    },
  },
};
</script>
